module.exports = "../../../../platform/assets/pageMainIcon/industry_yewushezhilei1.svg";